.root {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 48rem;
    margin: 2rem auto;
    padding: 0 1rem;
}

.term {
    font-size: 2.5rem;
    font-weight: 700;
    margin: 0;
}

.intro {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}

.question {
    font-size: 1.25rem;
    font-weight: 600;
    margin: 0;
}

.shortDef {
    font-size: 1.125rem;
    line-height: 1.5;
    margin: 0;
}

.body {
    font-size: 1rem;
    line-height: 1.6;
}

.aside {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    border-top: 1px solid rgb(0 0 0 / 10%);
    padding-top: 1rem;
}

.asideHeading {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.list {
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
}
